document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  const menuButton = document.querySelector('[data-menu-button]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const toast = document.querySelector('[data-toast]');

  const track = (eventName, params = {}) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  };

  document.querySelectorAll('[data-lead-cta]').forEach((link) => {
    link.addEventListener('click', () => {
      track('select_content', {
        content_type: 'lead_cta',
        item_id: link.getAttribute('data-lead-cta') || 'unknown'
      });
    });
  });

  document.querySelectorAll('[data-copy-email]').forEach((button) => {
    button.addEventListener('click', () => track('contact_email_click', {
      method: 'email_copy',
      location: button.getAttribute('data-contact-location') || 'page'
    }));
  });

  const leadForm = document.querySelector('[data-lead-form], #AddAIHubContact');
  if (leadForm) {
    const params = new URLSearchParams(window.location.search);
    const fieldMap = {
      utm_source: 'utm_source',
      utm_medium: 'utm_medium',
      utm_campaign: 'utm_campaign',
      utm_content: 'utm_content',
      utm_term: 'utm_term'
    };
    Object.entries(fieldMap).forEach(([paramName, fieldName]) => {
      const field = leadForm.querySelector(`[data-attribution="${fieldName}"]`);
      if (field) field.value = params.get(paramName) || '';
    });
    const landingPage = leadForm.querySelector('[data-attribution="landing_page"]');
    const referrer = leadForm.querySelector('[data-attribution="referrer"]');
    if (landingPage) landingPage.value = window.location.href;
    if (referrer) referrer.value = document.referrer;
    leadForm.addEventListener('submit', () => track('generate_lead', {
      form_id: leadForm.id || 'AddAIHubContact',
      lead_type: 'b2b_consultation'
    }));
  }

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-copy-email]').forEach((button) => {
    button.addEventListener('click', async () => {
      const email = button.getAttribute('data-copy-email');
      try {
        await navigator.clipboard.writeText(email);
        if (toast) {
          toast.textContent = 'Email copied';
          toast.classList.add('is-visible');
          setTimeout(() => toast.classList.remove('is-visible'), 2200);
        }
      } catch (error) {
        window.location.href = `mailto:${email}`;
      }
    });
  });

  window.addEventListener('scroll', () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  }, { passive: true });
});
